import axios from "axios";

export * from "./routes.constants";

//export const baseURL = "https://test.backend.theracedarzone.com.ng/api/v1";
export const baseURL = "https://live.backend.theracedarzone.com.ng/api/v1";

const axiosInstance = axios.create({
  baseURL,
  // baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json ",
    "Access-Control-Allow-Headers": "Content-Type",
  },
});

const addTokenToRequest = async (req) => {
  const token = localStorage.getItem("11p221#");
  req.headers.Authorization = `Bearer ${token}`;
  return req;
};

const redirectToLoginOnProfileUnauthorized = (error) => {
  const status = error?.response?.status;
  const requestUrl = error?.config?.url || "";
  const isProfileRequest = /^\/?user\/profile\/[^/?]+/.test(requestUrl);

  if (status === 401 && isProfileRequest) {
    localStorage.removeItem("11p221#");
    localStorage.removeItem("userId");

    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
  }

  return Promise.reject(error);
};

axiosInstance.interceptors.request.use(addTokenToRequest);
axiosInstance.interceptors.response.use(
  (response) => response,
  redirectToLoginOnProfileUnauthorized
);

export default axiosInstance;
